import React from 'react';
import { ColorPicker } from 'antd';
import type { ColorPickerProps as AntColorPickerProps } from 'antd';
import { C, FONT_UI } from '../../constants/design-tokens';
import { useBrandKit } from '../../brand-kit';

type ColorPickerProps = {
  value: string;
  onChange: (value: string) => void;
  label?: string;
};

export const ToolbarColorPicker: React.FC<ColorPickerProps> = ({ value, onChange, label }) => {
  const { colors: brandColors } = useBrandKit();
  const presets: AntColorPickerProps['presets'] = brandColors?.length
    ? [{ label: 'Colores de marca', colors: brandColors }]
    : undefined;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '3px' }}>
      <ColorPicker
        value={value}
        size='small'
        showText={false}
        presets={presets}
        onChange={color => onChange(color.toHexString())}
      />
      {label && <span style={{ fontSize: '9px', fontFamily: FONT_UI, color: C.textMuted }}>{label}</span>}
    </div>
  );
};
